import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { getRoles } from "../../../../Redux/reducer/session";
import { getAccounts } from "../../../../Redux/reducer/clients";
import {
  loadingHtml,
  infoContainer,
  errorContainer,
} from "../../../utils/functions";
import * as ClientActions from "../../../../Redux/actions/clientActions";
import * as CreditLineActions from "../../../../Redux/actions/credit-line";
import * as instanceActions from "../../../../Redux/api";

import iconEdit from "../../../../../static/images/icon-addnew-18px.svg";
import Modal from "../../../utils/customModal";
import CompanyForm from "../../../shared/customer/companyForm";

export class InstitutionProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentReady: false,
      enableEdit: false,
      modal: { show: false, content: null, handleClose: undefined },
    };
  }

  goBack = () => {
    this.props.history.push(`/bscadministrator/home`);
  };

  enableEdit = () => {
    const {
      t,
      institution,
      actions: { getClientAccounts },
      creditLineActions: { getCreditLineByCif },
    } = this.props;
    this.setState({
      modal: {
        show: true,
        content: loadingHtml(t("clients.profile.company.modal.creditLines")),
        handleChange: undefined,
      },
    });

    return getCreditLineByCif(institution.cif, institution.country.code).then(
      () => {
        this.setState({
          modal: {
            show: true,
            content: loadingHtml(t("clients.profile.company.modal.accounts")),
            handleChange: undefined,
          },
        });
        getClientAccounts(institution.cif, institution.country.code).then(
          () => {
            this.setState({
              modal: { show: false, content: null, handleChange: undefined },
              enableEdit: true,
              client: {
                status: institution.company.status,
                facilities: institution.company.facilityResponse,
              },
            });
          }
        );
      }
    );
  };

  modalFunction = () => {
    const { t } = this.props;
    var buttons = {
      SelBtn: { text: t("general.buttons.accept"), action: this.goBack },
    };

    var content = infoContainer(
      t("clients.profile.company.modal.profile.title"),
      t("clients.profile.company.modal.profile.message"),
      buttons
    );
    this.setState({ modal: { content, show: true } });
  };

  submitActions = (company) => {
    const {
      institution,
      instance: { instanceAction },
    } = this.props;
    const { modal } = this.state;
    const editUrl = `/companies/${institution.company.id}`;

    modal.show = true;
    modal.content = loadingHtml();
    this.setState({ modal });

    return instanceAction(editUrl, "put", company)
      .then(() => {
        this.modalFunction();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description
          );
        }
        modal.onClose = () =>
          this.setState({
            modal: { show: false, content: null, handleClose: undefined },
          });
        this.setState({ modal });
      });
  };

  render() {
    const { t, institution, canEdit, accounts } = this.props;
    const { enableEdit, modal } = this.state;
    return (
      <>
        <div className="proof">
          {canEdit && !enableEdit && (
            <div className="new-edit-div-client">
              <p className="new-edit-provider" onClick={this.enableEdit}>
                {t("general.labels.edit")}
              </p>
              <img src={iconEdit} className="iconEdit" />
            </div>
          )}
          <CompanyForm
            editCompany={true}
            enableEdit={enableEdit}
            company={institution}
            countryCode={institution.country.code}
            accounts={accounts}
            goBack={this.goBack}
            save={this.submitActions}
            method={`UPDATE`}
          />
        </div>
        <Modal show={modal.show} handleClose={modal.handleClose}>
          {modal.content}
        </Modal>
      </>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    accounts: getAccounts(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ClientActions, dispatch),
    creditLineActions: bindActionCreators(CreditLineActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(InstitutionProfile))
);
